/* Figma sample review presentation. RPSampleBox owns cart writes and pricing. */
(function () {
  'use strict';

  function view(state) {
    var count = state.totalUnits;
    var per = state.perBox;
    var boxes = state.boxCount;
    var samples = state.selectedSamples || [];
    var units = [];
    samples.forEach(function (sample) {
      for (var i = 0; i < sample.qty; i++) units.push(sample);
    });
    return {
      units: units,
      empty: Math.max(0, Math.max(per, boxes * per) - count),
      summary: boxes > 1 ? count + ' samples · ' + boxes + ' boxes' : count + ' of ' + per + ' selected',
      progress: state.activeBoxFill + ' of ' + per + ' SELECTED' + (boxes > 1 ? ' · Box ' + boxes + ' of ' + boxes : ''),
      checkout: count > 0
    };
  }

  function removeOne(api, state, index) {
    var sample = state.selectedSamples.find(function (s) { return s.index === index; });
    if (!sample) return Promise.resolve(false);
    return sample.qty > 1 ? api.setSampleQty(index, sample.qty - 1) : api.removeSample(index);
  }

  function initDialog(dialog) {
    if (dialog.dataset.v2SamplesInitialised) return;
    dialog.dataset.v2SamplesInitialised = 'true';
    var items = dialog.querySelector('[data-v2-sample-items]');
    var status = dialog.querySelector('[data-v2-sample-status]');
    var quantities = dialog.querySelector('[data-v2-sample-quantity-fields]');
    var checkout = dialog.querySelector('[data-v2-sample-checkout]');
    var header = dialog.closest('[data-v2-header]');
    var returnFocus = header.querySelector('[data-v2-samples-open]');
    var state = null;
    var busy = false;
    var signature = '';

    function api() { return window.RPSampleBox; }
    function message(text, error) {
      status.textContent = text;
      status.className = error ? 'v2-sample-drawer__status' : 'VisuallyHidden';
    }
    function node(tag, className, text) {
      var element = document.createElement(tag);
      if (className) element.className = className;
      if (text != null) element.textContent = text;
      return element;
    }
    function setBusy(value) {
      busy = value;
      if (value) dialog.setAttribute('aria-busy', 'true');
      else dialog.removeAttribute('aria-busy');
      dialog.querySelectorAll('[data-v2-sample-remove],[data-v2-sample-qty],[data-v2-sample-save]').forEach(function (element) { element.disabled = value; });
      var disabled = value || !state || !state.totalUnits;
      checkout.setAttribute('aria-disabled', String(disabled));
      if (disabled) checkout.setAttribute('tabindex', '-1');
      else checkout.removeAttribute('tabindex');
    }
    function render(next) {
      if (!dialog.isConnected) return;
      state = next;
      var model = view(next);
      dialog.querySelector('[data-v2-sample-summary]').textContent = model.summary;
      dialog.querySelector('[data-v2-sample-progress-label]').textContent = model.progress;
      dialog.querySelector('[data-v2-sample-added]').hidden = !next.totalUnits;
      dialog.querySelector('[data-v2-sample-total]').textContent = new Intl.NumberFormat('en-AU', {
        style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD', maximumFractionDigits: 0
      }).format(next.totalValueCents / 100);
      dialog.querySelector('[data-v2-sample-boxes]').textContent = next.totalUnits + (next.totalUnits === 1 ? ' sample' : ' samples') + ' · ' + next.boxCount + (next.boxCount === 1 ? ' box' : ' boxes');
      var progress = dialog.querySelector('[data-v2-sample-progress]');
      progress.replaceChildren();
      for (var i = 0; i < next.perBox; i++) progress.appendChild(node('span', i < next.activeBoxFill ? 'is-active' : ''));

      var nextSignature = JSON.stringify(next.selectedSamples);
      if (signature !== nextSignature) {
        signature = nextSignature;
        var fragment = document.createDocumentFragment();
        model.units.forEach(function (sample) {
          var card = node('div', 'v2-sample-drawer__item');
          card.dataset.sampleIndex = sample.index;
          var photo = node('img', 'v2-sample-drawer__image');
          var url;
          try { url = new URL(sample.img, window.location.origin); } catch (error) {}
          if (sample.img && url && (url.protocol === 'https:' || url.protocol === 'http:')) {
            photo.src = url.href; photo.alt = ''; photo.width = 100; photo.height = 80;
            card.appendChild(photo);
          } else {
            card.appendChild(node('span', 'v2-sample-drawer__image'));
          }
          var details = node('div', 'v2-sample-drawer__details');
          details.appendChild(node('p', 'v2-sample-drawer__name', sample.name));
          var source = Array.from(document.querySelectorAll('[data-sample-type][data-sample-variant]')).find(function (button) {
            return button.getAttribute('data-sample-variant') === String(sample.vid);
          });
          if (source && source.getAttribute('data-sample-type')) details.appendChild(node('p', 'v2-sample-drawer__type', source.getAttribute('data-sample-type')));
          card.appendChild(details);
          var remove = node('button', 'v2-sample-drawer__remove');
          remove.type = 'button'; remove.dataset.v2SampleRemove = sample.index;
          remove.setAttribute('aria-label', 'Remove one ' + sample.name + ' sample');
          remove.appendChild(node('span', 'v2-sample-remove-desktop', 'Remove'));
          var close = node('img'); close.src = dialog.dataset.removeIcon; close.width = 10; close.height = 10; close.alt = '';
          remove.appendChild(close);
          remove.appendChild(node('span', 'v2-sample-remove-mobile', '×'));
          card.appendChild(remove);
          fragment.appendChild(card);
        });
        for (var empty = 0; empty < model.empty; empty++) fragment.appendChild(dialog.querySelector('[data-v2-sample-empty]').content.cloneNode(true));
        items.replaceChildren(fragment);

        var quantityFields = document.createDocumentFragment();
        next.selectedSamples.forEach(function (sample) {
          var label = node('div', 'v2-sample-quantity');
          label.appendChild(node('span', '', sample.name));
          var input = node('input');
          input.type = 'number'; input.min = '1'; input.step = '1';
          input.max = String(next.maxSamples - next.totalUnits + sample.qty);
          input.value = sample.qty; input.dataset.v2SampleQty = sample.index;
          input.setAttribute('aria-label', sample.name + ' sample quantity');
          label.appendChild(input);
          var save = node('button', 'v2-sample-quantity__save', 'Update');
          save.type = 'button'; save.dataset.v2SampleSave = sample.index;
          save.setAttribute('aria-label', 'Update ' + sample.name + ' sample quantity');
          label.appendChild(save); quantityFields.appendChild(label);
        });
        quantities.replaceChildren(quantityFields);
      }
      setBusy(busy);
    }
    function refresh() { return api().getState().then(render); }
    function change(action, index, wasQuantity) {
      if (busy) return;
      setBusy(true); message('Updating your sample box…');
      Promise.resolve().then(action).then(function (result) {
        if (result === false || (result && result.ok === false)) throw new Error('Update failed');
        return refresh();
      }).then(function () {
        message('Your sample box is updated.');
        if (!dialog.open) return;
        var target = dialog.querySelector('[data-v2-sample-' + (wasQuantity ? 'qty' : 'remove') + '="' + index + '"]') || dialog.querySelector('[data-v2-samples-close]');
        target.disabled = false;
        target.focus();
      }).catch(function () {
        message('We could not update your sample box. Please try again.', true);
        return refresh().catch(function () {});
      }).finally(function () { setBusy(false); });
    }
    function openOnClick(event) {
      var opener = event.target.closest('[data-v2-samples-open]');
      if (!opener || !api() || !dialog.isConnected) return;
      event.preventDefault();
      var menu = opener.closest('[data-v2-menu]');
      returnFocus = menu ? header.querySelector('[data-v2-menu-open]') : opener;
      if (menu && menu.open) menu.close();
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('v2-menu-open');
      if (!busy) {
        state = null; setBusy(true); message('');
        refresh().catch(function () { message('Your sample box could not be loaded. Please try again.', true); }).finally(function () { setBusy(false); });
      }
    }
    function close() {
      document.documentElement.classList.remove('v2-menu-open');
      var target = returnFocus && returnFocus.isConnected ? returnFocus : document.querySelector('[data-v2-samples-open]');
      if (target) target.focus();
    }
    function onClick(event) {
      if (event.target.closest('[data-v2-samples-close]')) { dialog.close(); return; }
      if (event.target === dialog) {
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        return;
      }
      if (event.target.closest('[data-v2-sample-checkout]') && (busy || !state || !state.totalUnits || checkout.getAttribute('aria-disabled') === 'true')) { event.preventDefault(); return; }
      if (busy) { if (event.target.closest('a')) event.preventDefault(); return; }
      if (event.target.closest('[data-v2-sample-checkout]') && state) {
        var pending = Array.from(dialog.querySelectorAll('[data-v2-sample-qty]')).find(function (input) {
          var sample = state.selectedSamples.find(function (item) { return item.index === Number(input.dataset.v2SampleQty); });
          return sample && Number(input.value) !== sample.qty;
        });
        if (pending) { event.preventDefault(); onQuantity({ target: pending });  return; }
      }
      var save = event.target.closest('[data-v2-sample-save]');
      if (save) {
        var field = dialog.querySelector('[data-v2-sample-qty="' + save.dataset.v2SampleSave + '"]');
        onQuantity({ target: field });
        return;
      }
      var remove = event.target.closest('[data-v2-sample-remove]');
      if (remove && state) change(function () { return removeOne(api(), state, Number(remove.dataset.v2SampleRemove)); }, remove.dataset.v2SampleRemove, false);
      var add = event.target.closest('[data-v2-sample-add]');
      if (add && new URL(window.location.href).searchParams.get('view') === 'samples') {
        var available = document.querySelector('.js-sample-select[aria-pressed="false"]:not(:disabled)');
        if (available) { event.preventDefault(); returnFocus = available; dialog.close(); }
      }
    }
    function onQuantity(event) {
      var input = event.target.closest('[data-v2-sample-qty]');
      if (!input || !state) return;
      if (!input.checkValidity() || !Number.isInteger(Number(input.value))) {
        message('Choose a whole quantity between ' + input.min + ' and ' + input.max + '.', true);
        var sample = state.selectedSamples.find(function (s) { return s.index === Number(input.dataset.v2SampleQty); });
        if (sample) input.value = sample.qty;
        return;
      }
      var index = Number(input.dataset.v2SampleQty);
      var quantity = Number(input.value);
      var current = state.selectedSamples.find(function (sample) { return sample.index === index; });
      if (current && current.qty === quantity) return;
      change(function () { return api().setSampleQty(index, quantity); }, index, true);
    }
    function onQuantityKey(event) {
      if (event.key === 'Enter' && event.target.matches('[data-v2-sample-qty]')) { event.preventDefault(); onQuantity(event); }
    }
    function onState(event) { if (dialog.open && event.detail) render(event.detail); }
    function unload(event) {
      if (!event.target.contains(dialog)) return;
      if (dialog.open) dialog.close();
      document.removeEventListener('click', openOnClick);
      document.removeEventListener('repubblica:sample_box_changed', onState);
      document.removeEventListener('shopify:section:unload', unload);
      dialog.removeEventListener('click', onClick);
      dialog.removeEventListener('keydown', onQuantityKey);
      dialog.removeEventListener('close', close);
      delete dialog.dataset.v2SamplesInitialised;
    }
    document.addEventListener('click', openOnClick);
    document.addEventListener('repubblica:sample_box_changed', onState);
    document.addEventListener('shopify:section:unload', unload);
    dialog.addEventListener('click', onClick);
    dialog.addEventListener('keydown', onQuantityKey);
    dialog.addEventListener('close', close);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { view: view, removeOne: removeOne, initDialog: initDialog };
  if (typeof window !== 'undefined') window.RPV2Samples = { initDialog: initDialog };
})();

